import * as React from 'react';
import { DatePicker } from 'wix-ui-tpa';
import { st, classes } from './WeeklyDatePicker.st.css';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import WeeklyContext from '../../../context/weeklyContext';
var WeeklyDatePicker = function (_a) {
    var datePickerSelectHandler = _a.datePickerSelectHandler, datePickerRef = _a.datePickerRef, setDatePickerIsShown = _a.setDatePickerIsShown;
    var _b = React.useContext(WeeklyContext), locale = _b.locale, firstDay = _b.firstDay;
    var _onChange = function (date) {
        datePickerSelectHandler(date);
        setDatePickerIsShown(false);
    };
    return (React.createElement(ClickAwayListener, { onClickAway: function () { return setDatePickerIsShown(false); } },
        React.createElement("div", { className: st(classes.DatePicker), ref: datePickerRef },
            React.createElement(DatePicker, { className: classes.root, onChange: _onChange, firstDayOfWeek: firstDay, locale: locale }))));
};
export default React.memo(WeeklyDatePicker);
//# sourceMappingURL=WeeklyDatePicker.js.map